import { render, staticRenderFns } from "./roleTree.vue?vue&type=template&id=05997cdc&lang=pug&"
import script from "./roleTree.vue?vue&type=script&lang=js&"
export * from "./roleTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports